import { GzEasmServicesPerProtocolWebComponent } from './component/GzEasmServicesPerProtocolWebComponent';

export { GzEasmServicesPerProtocolWebComponent };
